module.exports = __webpack_public_path__ + "img/revenueContribution.dfd5018e.png";